export const EshbelPos = -100;
export const Format = 'P';
export const Report = 'R';
export const Field = 'F';
